import { Formik } from "formik";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";

import FormDisplay from "./FormDisplay";
import pages from "../../../../constants/pages";
import { useAxios } from "../../../../hooks";
import { ButtonFooter } from "../../../../components";
import { alert } from "../../../../redux/slices/alertSlice";
import validationSchema from "./validationSchema";
import { objectFromFormData } from "./broadcastDetailsObject";

export default function Form({
  formData,
  activeBot,
  setFormData,
  groupList,
  scheduledTime,
  setScheduledTime,
  templates,
  channel,
  fields,
}) {
  const axios = useAxios();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [editState, setEditState] = useState(true);

  useEffect(() => {
    if (Boolean(formData.ID)) {
      setEditState(false);
    }
  }, [formData.ID]);

  return (
    <Formik
      enableReinitialize
      validateOnMount
      initialValues={formData}
      validationSchema={validationSchema}
      onSubmit={(formData, { setSubmitting }) => {
        var data = objectFromFormData(formData);

        axios({
          url: "/broadcast_email/create_broadcast?agent_id=" + activeBot.ID,
          method: "POST",
          data: data,
        }).then((res) => {
          if (res.status) {
            setSubmitting(false);
            setFormData(formData);
            setEditState(false);
            navigate(pages.sailBroadcastEmailList.route);
            dispatch(
              alert({
                type: "success",
                message: res.message.displayMessage,
              })
            );
          }
        });
      }}
    >
      {(formikProps) => (
        <React.Fragment>
          <FormDisplay
            formikProps={formikProps}
            editState={editState}
            setEditState={setEditState}
            scheduledTime={scheduledTime}
            setScheduledTime={setScheduledTime}
            groupList={groupList}
            activeBot={activeBot}
            templates={templates}
            fields={fields}
            channel={channel}
          />

          <ButtonFooter
            ID={formikProps.values.ID}
            formikProps={formikProps}
            editState={editState}
            setEditState={setEditState}
          />
        </React.Fragment>
      )}
    </Formik>
  );
}
